import BookingsPage from "./BookingsPage";

export default BookingsPage;
